import { createStyles, ListItem } from '@quickbit/qb-design-system';

interface Props {
  enabled: boolean;
  subtitle?: string;
}
export const AuthenticatorEnabledStatus = ({ enabled, subtitle }: Props) => {
  const styles = useStyles();
  const enabledStatusMsg = enabled ? 'Enabled' : 'Disabled';
  return (
    <ListItem
      subtitle={subtitle}
      title={enabledStatusMsg}
      css={enabled ? styles.enabledStatus : styles.disabledStatus}
      icon="security"
    />
  );
};

const useStyles = createStyles(({ spacing, palette }) => ({
  enabledStatus: {
    border: '2px solid',
    borderRadius: spacing.xxs,
    borderColor: palette.success.x500 + '!important',
  },
  disabledStatus: {
    border: '2px solid',
    borderRadius: spacing.xxs,
    borderColor: palette.danger.x500 + '!important',
  },
}));
